// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header__oE2FH","isLogo":"Header__isLogo__1rMUN","title":"Header__title__3Wcfe","clientLogo":"Header__clientLogo__1a2eL","logoutButton":"Header__logoutButton__2s0gy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.css
// module id = 534
// module chunks = 0